import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 Disha Medical Store. All rights reserved.</p>
      <p>Contact: 8401477362 | Email: dishamedicalstore9@gmail.com</p>
    </footer>
  );
}

export default Footer;